// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3esoD","title":"Info_title__3N6IR","links":"Info_links__1kf9c","link":"Info_link__gcCwT","logo":"Info_logo__12ovV"};